    // ajax setup for POST method
    const csrftoken = jQuery("[name=csrfmiddlewaretoken]").val();
    const csrfSafeMethod = (method) => {
        // these HTTP methods do not require CSRF protection
        return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
    }
    $.ajaxSetup({
      beforeSend: function(xhr, settings) {
        if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
          xhr.setRequestHeader("X-CSRFToken", csrftoken);
        }
      },
    });

    // define user is authenticated
    const check_user = () => {
      // const is_authenticated = "{{ request.user.is_authenticated }}"
      const is_authenticated = document.getElementById('main_container').getAttribute('data-is_auth')
      if ( is_authenticated == 'True' ) {
        return true
      }
      return false
    }

    // define 숫자에 콤마 추가
    const addComma = (value) => {
      return Number(value).toLocaleString('en');
    }

    // define 금액 변경
    const changePrice = (quantity_line) => {
      const quantity = quantity_line.val()
      const price = quantity_line.data('price')
      let total_price = Number(quantity) * Number(price);
      total_price = addComma(total_price)
      quantity_line.parent().next().find('span').html(total_price)
    }

    // define 전체 금액 변경
    const changeTotalPrice = () => {
      let total_price = 0
      Array.from(document.querySelectorAll('tr.cart'), tr => {
        const price = Number($(tr).find('.price').html().replace(/,/gi, ''))
        total_price += price
      })
      $('#total_price').html(addComma(total_price))
    }

		// define get_cart_value
		const get_cart_value = (tr) => {
			var cart_id = tr.find('input[name=selected_cart]').val()
			var option_id = tr.find('input[name=quantity]').data('option_id')
			var m_price = tr.find('input[name=quantity]').data('price')
			var quantity = tr.find('input[name=quantity]').val()
			var value = cart_id + '_' + option_id + '_' + quantity + '_' + m_price;
			return value
		}

		// 수량 변경 시 금액 변경
    $('input[name=quantity]').change(function (){
      changePrice($(this))
      changeTotalPrice()
    })

    // 선택 삭제
    $("#act_delete").click(function() {
			if ($('input[name=selected_cart]').is(':checked')) {
				if(confirm('선택하신 상품을 삭제하시겠습니까?')) {
					$("#submit_type").val('delete');
					$("#action_form").submit();
					return true;
				}
				else{
					return false;
				}
			} else {
				alert('삭제하실 상품을 선택하여주세요.');
				return false;
			}
    })

    // 선택 구매
    $("#act_purchase_selected").click(function() {
			if ($('input[name=selected_cart]').is(':checked')) {
				var values = [];
				$('input[name=selected_cart]:checked').each(function () {
					var tr = $(this).parent().parent().parent();
					var value = get_cart_value(tr);
					values.push(value);
				});
				$("#submit_type").val('purchase');
				$("#submit_value").val(values.join());
				$("#action_form").submit();
				return false;
			} else {
				alert('구매할 상품을 선택하여주세요.');
				return false;
			}
		})

    // 전체 구매
    $("#act_purchase_all").click(function() {
			var values = [];
			$('input[name=selected_cart]').each(function () {
				var tr = $(this).parent().parent().parent();
				var value = get_cart_value(tr);
				values.push(value);
			});
			$("#submit_type").val('purchase');
			$("#submit_value").val(values.join());
			$("#action_form").submit();
			return false;
		})

    $(document).ready(function (){
      changeTotalPrice()
    })
